export const API_SERVER = process.env.REACT_APP_FOREST_CORE_URL;
